import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { theme } from '@marriott/mi-ui-library-shop';

export const StyledFormContainer = styled.div.attrs(props => props)`
  ${rtl`
    &.serp-search-form{
      min-height: auto;  
      @media ${theme.mediaQuery.mobileOnly} {
          min-height: auto;  
      }
    }
  `}
`;
